// This get replaced at build time via sed. See `bitbucket-pipelines.yml`.
const injectedEnv = 'prod';

const currentEnv = () => {
	return injectedEnv || 'local';
}

const isProd = () => {
    return injectedEnv === 'prod';
}

export { currentEnv, isProd };